import { MenuOutlined } from "@ant-design/icons";
import { Button, Table, notification } from "antd";
import arrayMove from "array-move";
import React, { useEffect, useState } from "react";
import {
  SortableElement,
  SortableHandle,
  SortableContainer as sortableContainer,
} from "react-sortable-hoc";
import { AdminService } from "../../../services/AdminService";

const Priority = () => {
  const [dataSource, setDataSource] = useState(null);
  useEffect(() => {
    AdminService.getProjectsPriority().then((data) => {
      setDataSource(data.data);
    });
  }, []);
  const DragHandle = SortableHandle(() => (
    <MenuOutlined style={{ cursor: "grab", color: "#999" }} />
  ));
  const SortableItem = SortableElement((props) => <tr {...props} />);
  const SortableContainer = sortableContainer((props) => <tbody {...props} />);
  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const newData = arrayMove(
        [].concat(dataSource),
        oldIndex,
        newIndex
      ).filter((el) => !!el);
      setDataSource(newData);
    }
  };

  const DraggableContainer = (props) => (
    <SortableContainer
      useDragHandle
      disableAutoscroll
      helperClass="row-dragging"
      onSortEnd={onSortEnd}
      {...props}
    />
  );

  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    const index = dataSource.findIndex(
      (x) => x.index === restProps["data-row-key"]
    );
    return <SortableItem index={index} {...restProps} />;
  };

  const columns = [
    {
      title: "Sort",
      dataIndex: "sort",
      width: 30,
      className: "drag-visible",
      render: () => <DragHandle />,
    },
    {
      title: "Project Name",
      dataIndex: "name",
      className: "drag-visible",
    },
  ];
  const saveData = () => {
    const a = [];
    dataSource.forEach((d) => {
      a.push(d.id);
    });
    AdminService.saveNewProjectPriorities(a).then((data) => {
      notification.success({
        message: "Success!",
        description: "New priorities successfully saved ",
      });
    });
  };
  return (
    <div style={{ maxWidth: "600px" }} className=" p-5 bg-gray-50 border">
      {dataSource && (
        <Table
          className="border"
          pagination={false}
          dataSource={dataSource}
          columns={columns}
          rowKey="index"
          components={{
            body: {
              wrapper: DraggableContainer,
              row: DraggableBodyRow,
            },
          }}
        />
      )}
      <br />
      <Button type="primary" onClick={saveData}>
        Save
      </Button>
    </div>
  );
};

export default Priority;
